import find from 'lodash/find';
import isUndefined from 'lodash/isUndefined';
import round from 'lodash/round';

import './predefinedColor.scss';

class PredefinedColorCtrl {
    constructor(imagesService, dataService, $scope) {
        this.imagesService = imagesService;
        this.dataService = dataService;
        this.$scope = $scope;
    }

    $onInit() {
        if (this.selectedPacket && Object.keys(this.selectedPacket).length > 0) {
            this.setColorFromPredefined(this.selectedPacket);
        } else {
            this.setDefaultPredefinedSetup();
        }
    }

    checkPredefinedSet(predefinedSet) {
        this.selectedPacket = predefinedSet;
        this.setColorFromPredefined(predefinedSet);
    }

    setDefaultPredefinedSetup() {
        this.predefinedColors = this.dataService.getAttributeOptions('predefinedCombination');
        this.selectedPacket = this.predefinedColors[0];
        this.setColorFromPredefined(this.predefinedColors[0]);
    }

    getColorProperty(id, fieldName) {
        if (id) {
            const color = find(this.colors, el => el.id === id);

            return color.attributes[fieldName];
        }

        if (fieldName === 'imgSrc') {
            return null;
        }

        return 'unset';
    }

    getImageUrl(imgSrc) {
        if (imgSrc) {
            return this.imagesService.getFullUrl(imgSrc);
        }

        return '/img/no-image.jpg';
    }

    getPrice() {
        if (!isUndefined(this.selectedPacket) &&
            !isUndefined(this.selectedPacket.attributes) && this.dataService.freshPrice) {
            // const prevPrice = this.dataService.price - this.dataService.basePrice;
            const basePrice = this.dataService.basePrice;
            const percentage = this.selectedPacket.attributes.precentageSurcharge;
            const price = (basePrice * percentage) / 2;
            return round(price);
        }

        return '';
    }
}

PredefinedColorCtrl.$inject = ['imagesService', 'dataService', '$scope'];

export default PredefinedColorCtrl;